import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';
import { CreateGuesser } from 'shared/react-admin/Guessers';

export const StyledCreateGuesser = styled(CreateGuesser)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '8px',
  backgroundColor: theme.palette.background.default,
  padding: '24px',
  '& .MuiCardContent-root': {
    padding: 0,
  },
  '& .MuiCardContent-root:last-child': {
    padding: 0,
  },
  '& .RaCreate-main': {
    margin: 0,
  },
}));

export const BoxStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  paddingBottom: '24px',
});
